import { Injectable } from '@angular/core';
import { 
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest, } from '@angular/common/http';
import {Observable} from 'rxjs';
import { AuthService } from '../services';
import { routes } from 'src/app/consts';
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  
  public routers: typeof routes = routes;
  constructor(private authService:AuthService) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const accessToken = localStorage.getItem("token");
    if (accessToken) {
      req = req.clone({
        setHeaders: {
          "Content-Type": "application/json; charset=utf-8",
          Accept: "application/json",
          AuthToken: accessToken,
        },
      });
    }
    return next.handle(req);
  }
}
